<template>
    <div class="reset-dialog-wrapper">
        <el-dialog class="reset-dialog" :visible.sync="dialogVisible" width="360px" :modal-append-to-body="false" :before-close="handleClose" :close-on-click-modal="false" :custom-class="'password-dialog'">
            <div class="reset-title">修改密码</div>
            <div class="reset-form">
                <el-form :model="resetForm" :rules="rules" ref="resetForm" width="440px">
                    <el-form-item prop="phone">
                        <el-input v-model="resetForm.phone" placeholder="请输入手机号进行验证"></el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <el-input v-model="resetForm.code" placeholder="验证码">
                            <template slot="append">
                                <el-button class="send-code"  @click="sendCode" :disabled="!canSendCode">
                                    {{ btnText }}
                                </el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="resetForm.password" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item prop="repeatPassword">
                        <el-input v-model="resetForm.repeatPassword" placeholder="请再次输入新密码"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button class="btn" @click="handleClose">取 消</el-button>
                    <el-button class="btn btn-primary submit-btn" type="primary" @click="submitForm('resetForm')">修 改</el-button>
                </div>
            </div>
        </el-dialog>
        <verify-modal ref="resetModal" @success="verifyCaliback" :id="'slider-bar1'"></verify-modal>
    </div>
</template>
<script>
import Api from '../api'
import verifyModal from '@/components/VerifyModal'

export default {
    name: 'ChangePassword',
    components: {
        verifyModal
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if((/[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/g.test(value))&&(/\d+/g.test(value))&&(/[A-Z]+/g.test(value))&&(/[a-z]+/g.test(value))&&value.length>=10&&value.length<=20 ){
                callback();
            } else {
                callback(new Error('密码要包含大小字母数字特殊字符，长度10-20'));
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (value !== this.resetForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            dialogVisible: false,
            resetForm: {
                phone: '',
                code: '',
                password: '',
                repeatPassword: '',
            },
            rules: {
                phone: [
                    {required:true,message:'请输入手机号',trigger:'blur'},
                    {min:11,max:11,message:'请输入11位手机号',trigger:'blur'}
                ],
                code: [
                    // {required:true,message:'请输入验证码',trigger:'blur'},
                    {min:6,max:6,message:'请输入6位验证码',trigger:'blur'}
                ],
                password: [
                    {required:true,message:'请输入密码',trigger:'blur'},
                    { validator: validatePass, trigger: 'blur' }
                ],
                repeatPassword: [
                    {required:true,message:'请再次输入密码',trigger:'blur'},
                    { validator: validatePass2, trigger: 'blur' }
                ]
            },
            btnText:'发送验证码',
            disabled:false,
            timer:null,
            count:60
        }
    },
    methods: {
        //显示弹窗
        showDialog() {
            this.dialogVisible = true
        },
        //提交申请测试
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        mobile: this.resetForm.phone,
                        code: this.resetForm.code,
                        newPassword: this.resetForm.password
                    }
                    Api.changePassword(params).then(res => {
                        if (res.code === 200) {
                            this.$message.success('密码修改成功！')
                            this.handleClose()
                        }
                    }).catch(err => {
                        this.$message.error(err.msg)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        sendCode(){
            if(!this.resetForm.phone){
                this.$message({
                    type:'warning',
                    message:'请输入手机号'
                })
                return
            }
            if(this.canSendCode) {
                this.$refs.resetModal.invokeModal()
            }
        },
        countDown(){
            this.timer = setInterval(()=>{
                if(this.count === 0){
                    clearInterval(this.timer)
                    this.timer = null
                    this.btnText = '发送验证码'
                    this.disabled = false
                    this.count = 60
                }else{
                    this.count--
                    this.btnText = `${this.count}秒后重发`
                    this.disabled = true
                }
            },1000)
        },
        handleClose() {
            this.$refs['resetForm'].resetFields()
            this.dialogVisible = false
            clearInterval(this.timer)
            this.timer = null
            this.btnText = '发送验证码',
            this.count = 60
        },
        validPhone() {
            return this.resetForm.phone.length == 11
        },
        verifyCaliback(info) {
            Api.changePassSendCode({
              mobile: this.resetForm.phone,
              ...info
            }).then(res => {
                if(res.code === 200){
                    this.$message({
                        type:'success',
                        message:'验证码发送成功'
                    })
                    this.countDown()
                }
            }).catch(err => {
                this.$message({
                    type:'error',
                    message: err.msg
                })
            })
        }
    },
    computed: {
        canSendCode() {
            if(this.timer) return false
            if(this.validPhone(this.resetForm.phone)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>
<style lang="scss">
.mobile{
  .password-dialog{
        transform: scale(2.5);
        margin-top: 40vh !important;
     }
}
</style>
<style lang="scss" scoped>
.reset-dialog-wrapper {
    width: 585px;
    background: #FFFFFF;

    .reset-dialog {
        /deep/ .el-dialog {
            border-radius: 8px;
        }

        /deep/ .el-dialog__header {
            padding: 0;

            .el-dialog__headerbtn {
                top: 15px;
                right: 15px;

                .el-dialog__close {
                    width: 13px;
                    height: 13px;
                    font-family: PingFang SC;
                    font-weight: 200;
                    color: #556F88;
                }
            }
        }
    }
    .reset-title {
        // width: 65px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 45px;
    }
    .reset-form {
        /deep/ .el-form-item {
            height: 62px;
            margin-bottom: 0;
            &.is-error {
                .el-input__inner {
                    background-color: #FFF3F3;
                    color: #333333;
                    font-weight: 400;
                }
                .el-input-group__append {
                    background-color: #FFF3F3;
                }
            }
        }
        /deep/ .el-form-item__label {
            line-height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #111111;
        }
        /deep/ .el-input {
            margin-bottom: 2px;
        }
        /deep/ .el-input__inner {
            background-color: #F2F3F4;
            border: none;
        }
        /deep/ .el-input-group__append {
            background-color: #F2F3F4;
            border: none;
            .send-code {
                border: none;
                color: #0078EF;
                &:hover {
                    background-color: transparent;
                }
                &:disabled {
                    color: #C0C4CC;
                }
            }
        }
        /deep/ .el-form-item__error {
            position: relative;
            padding-left: 15px;
            color: #FF2525;
            font-family: Source Han Sans CN;
            line-height: 18px;
            &::before {
                position: absolute;
                top: 3px;
                left: 0;
                display: block;
                content: " ";
                width: 13px;
                height: 13px;
                background: url('../assets/icon-error.png') center center / contain no-repeat;
            }
        }
        /deep/ .el-input__inner:focus {
            border-color: #60B1F9;
        }

        /deep/ .el-checkbox-group {
            display: grid;
            grid-template-columns: 136px 1fr;

            .el-checkbox__label {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
            }

            .el-checkbox__inner {
                box-sizing: border-box;
                width: 22px;
                height: 22px;
                border: 1px solid #DDE3E8;
                border-radius: 4px;

                &::after {
                    display: none;
                }
            }

            .is-checked .el-checkbox__inner {
                background: url('../assets/bg-checked.png') center center / contain no-repeat;
            }
        }
        .dialog-footer {
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
        }
        .btn {
            font-size: 16px;
            padding: 10px 52px;
        }

        .submit-btn {
            background: #0078EF;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 400;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue